import { useEffect, useState } from "react";
import "./basemap.css";

import baseMapOrtofot from "./../assets/images/baseMapOrtofot.jpg";
import greyMap from "./../assets/images/greyMap.jpg";
import topographicMap from "./../assets/images/topographicMap.jpg";
import TileLayer from "@arcgis/core/layers/TileLayer.js";
import Basemap from "@arcgis/core/Basemap.js";
import texts from "../assets/texts/texts";
import "@esri/calcite-components/components/calcite-icon";
import "@esri/calcite-components/components/calcite-button";
import "@esri/calcite-components/components/calcite-tooltip";
import useIsMobile from "./MobileDetection";


//const texts = czech;
let visibility = false;
function BaseMap({ view }) {
  const [visibilityBasemappanel, setVisibilityToolspanel] = useState(false);
  const [viewRedy, setViewRedy] = useState(false);
  const [ortofoto, setOrtofoto] = useState(null);
  const [zoom, setZoom] = useState(null);

  const isMobile = useIsMobile();

  const visibleHandler = () => {
    const rightConerEsri = document.querySelector(".esri-ui-bottom-right");
    const searchWidget = document.querySelector(".arcgis-search");
     const cookieButon = document.querySelector("#cookie-settings-btn");
    const map_container__leftBottom = document.querySelector(
      ".map_container__leftBottom",
    );
    if (visibilityBasemappanel) {
      setVisibilityToolspanel(false);
      visibility = false;
      rightConerEsri.classList.remove("panel-open");
      map_container__leftBottom.classList.add("panel-open");
      cookieButon.classList.remove("panel-open");
    } else {
      map_container__leftBottom.classList.remove("panel-open");
      setVisibilityToolspanel(true);

      visibility = true;
      rightConerEsri.classList.add("panel-open");
      cookieButon.classList.add("panel-open");
    }
    if (window.innerHeight < 350 && visibility) {
      searchWidget.classList.add("panel-open");
    } else if (!visibility) {
      searchWidget.classList.remove("panel-open");
    }
  };

  useEffect(() => {
    const searchWidget = document.querySelector(".arcgis-search");
   
   
    const handleResize = () => {
      if (window.innerHeight < 350 && visibility) {
        searchWidget.classList.add("panel-open");
        
      } else if (visibility) {
        searchWidget.classList.remove("panel-open");
       
      }
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [view]);
  useEffect(() => {
    if (viewRedy === false && view) {
      setViewRedy(true);

      var ortofotoBasemap = new TileLayer({
        url: "https://gis.brno.cz/ags2/rest/services/PUBLIC/basemap_ortofoto_wgs_aktualni_tiled/MapServer",
      });

      var baseMapOrtofoto = new Basemap({
        baseLayers: [ortofotoBasemap],
        title: texts.basemaps.maps.ortophoto,
        id: "ortofoto",
      });

      setOrtofoto(baseMapOrtofoto);
      view.map.basemap = "topo";
      const zoomWidget = document.querySelector(".arcgis-zoom");
      zoomWidget.style.display = "none";
      const zoom = document.querySelector("arcgis-zoom");
      setZoom(zoom);
    }
  }, [view]);

  const baseMapHendler = (basemap) => {
    if (view) {
      if (basemap === "topographic") {
        view.map.basemap = "topo";
      } else if (basemap === "dark-gray") {
        view.map.basemap = "dark-gray";
      } else if (basemap === "ortofoto") {
        view.map.basemap = ortofoto;
      }
    }
  };
  return (
    <>
      <div
        className={[
          "map_container__leftBottom",
          visibilityBasemappanel ? "panel-open" : "",
        ].join(" ")}
      >
        <calcite-button
          id="button-plus"
          className="esriBesmapButtons"
          scale="s"
          onClick={() => {
            zoom.zoomIn();
          }}
        >
          <calcite-icon icon="plus" scale="l"></calcite-icon>
        </calcite-button>
        <calcite-button
          id="button-minus"
          className="esriBesmapButtons"
          scale="s"
          onClick={() => {
            zoom.zoomOut();
          }}
        >
          <calcite-icon icon="minus" scale="l"></calcite-icon>
        </calcite-button>

        <calcite-button
          id="button-basemap"
          className="esriBesmapButtons"
          scale="s"
          onClick={() => {
            visibleHandler();
          }}
        >
          <calcite-icon icon="basemap" scale="l"></calcite-icon>
        </calcite-button>
        {!isMobile && (
          <>
            <calcite-tooltip reference-element="button-plus">
              <span className="my-tooltip-text">
                {texts.basemaps.buttons.plus}
              </span>
            </calcite-tooltip>
            <calcite-tooltip reference-element="button-minus">
              <span className="my-tooltip-text">
                {texts.basemaps.buttons.minus}
              </span>
            </calcite-tooltip>
            <calcite-tooltip reference-element="button-basemap">
              <span className="my-tooltip-text">
                {texts.basemaps.buttons.basemaps}
              </span>
            </calcite-tooltip>
          </>
        )}
      </div>
      {visibilityBasemappanel && (
        <div id="basemappanel" className="baseMapContainer">
          <div id="basemapWraper">
            <button
              className="baseMap__Item basemap--hover"
              onClick={() => {
                baseMapHendler("ortofoto");
              }}
            >
              <img
                className="baseMap__image"
                src={baseMapOrtofot}
                alt={texts.basemaps.maps.ortophoto}
              />
              <p className="baseMap__text">{texts.basemaps.maps.ortophoto}</p>
            </button>
            <button
              className="baseMap__Item basemap--hover"
              onClick={() => {
                baseMapHendler("topographic");
              }}
            >
              <img
                className="baseMap__image"
                src={topographicMap}
                alt={texts.basemaps.maps.topo}
              />
              <p className="baseMap__text">{texts.basemaps.maps.topo}</p>
            </button>
            <button
              className="baseMap__Item basemap--hover"
              onClick={() => {
                baseMapHendler("dark-gray");
              }}
            >
              <img
                className="baseMap__image"
                src={greyMap}
                alt={texts.basemaps.maps.dark}
              />
              <p className="baseMap__text">{texts.basemaps.maps.dark}</p>
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default BaseMap;
